import { Nullable } from '@/shared/types/app.types'
import { SwiperOptions } from 'swiper/types/swiper-options'

export enum StatisticalAnalysisTypeNavigation {
    NAVIGATION = 'navigation',
    INFO = 'information'
}
export interface StatisticalAnalysisHeaderNavigationItems<T> {
    label: string
    key: Nullable<T>
    value: number
    icon: string
    color?: string
    percentage?: number
}

export interface StatisticalAnalysisHeaderTopValues {
    showTotal: boolean
    total: number
    startDate: Date
    endDate: Date
    elementType: string
}

export interface StatisticalAnalysisHeaderStyles {
    background: string
    icon: string
}
export interface StatisticalAnalysisHeaderValues {
    header: StatisticalAnalysisHeaderTopValues,
    navigationType: StatisticalAnalysisTypeNavigation
    navigationItems: StatisticalAnalysisHeaderNavigationItems<any>[],
    styles: StatisticalAnalysisHeaderStyles
    optionsSlider?: SwiperOptions
}

export interface StatisticalAnalysisHeaderState {
    activeItem: number
    positionStatus: number
    swiperOptions: SwiperOptions
}
export const initialStatisticalAnalysisHeaderState =
    (): StatisticalAnalysisHeaderState => ({
        swiperOptions: {
            slidesPerView: 5,
            spaceBetween: 40,
            slidesPerGroup: 1,
            allowTouchMove: false,
            loop: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            breakpoints: {
                1248: {
                    slidesPerView: 5,
                    spaceBetween: 40
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                640: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 10
                }
            }
        },
        activeItem: 0,
        positionStatus: 0
    })
